import { createListenCollectionEpic, createListenDocEpic } from 'src/firebase';
import { actions, actionTypes } from './redux';

const ListenTrendingCategoriesEpic$ = createListenCollectionEpic({
  collection: 'trendingCategories',
  listenType: actionTypes.LISTEN_COLLECTION,
  unlistenType: actionTypes.UNLISTEN_COLLECTION,
  changeCollection: actions.changeCollection,
});

const ListenTrendingCategoryDetailEpic$ = createListenDocEpic({
  collection: 'trendingCategories',
  listenType: actionTypes.LISTEN_DOC,
  unlistenType: actionTypes.UNLISTEN_DOC,
  changeDoc: actions.changeDoc,
});

export {
  ListenTrendingCategoriesEpic$,
  ListenTrendingCategoryDetailEpic$
};



// WEBPACK FOOTER //
// ./src/trendingCategories/epics.ts